import { FormEvent } from 'react'
import cx from 'classnames'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import HeadlineFour from 'ui-component-library/components/00-Primitives/Headlines/HeadlineFour'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Ruler from 'ui-component-library/components/00-Primitives/Ruler'
import Select from 'ui-component-library/components/00-Primitives/Inputs/Select'
import Button from 'content-components/_Primatives/Button'
import useSticky from '../useSticky'
import baseStyle from '../style.scss'
import style from './style.scss'

type Props = {
  bodyText: string
  headlineText: string
  purchaseLinkText: string
  availabilityText: string
  valuePropText: string
  region: string
  onSubmit: () => void
  onChangeRegion: (region: string) => void
  regionDropdown: {
    placeholderText: string
    options: { key: string; value: string }[]
  }
}

function PurchaseCTA({
  bodyText,
  availabilityText,
  purchaseLinkText,
  headlineText,
  onChangeRegion,
  valuePropText,
  onSubmit,
  region,
  regionDropdown,
}: Props) {
  const { stickyRef, isSticky } = useSticky<HTMLFormElement>(130)

  function handleChangeRegion(data: { value: string }) {
    const { value } = data
    onChangeRegion(value)
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    onSubmit()
  }

  return (
    <div
      className={cx(baseStyle.wrapper, {
        [baseStyle.stickyWrapper]: isSticky,
      })}
    >
      <div className={baseStyle.content}>
        <HeadlineTwo className={baseStyle.headlineText}>
          {headlineText}
        </HeadlineTwo>
        <Ruler className={baseStyle.ruler} />
        <Paragraph className={baseStyle.bodyText}>{bodyText}</Paragraph>
        <div className={baseStyle.availabilityText}>{availabilityText}</div>
      </div>
      <form
        onSubmit={handleSubmit}
        ref={stickyRef}
        className={cx(baseStyle.ctaWrapper, {
          [baseStyle.sticky]: isSticky,
        })}
      >
        <HeadlineFour className={baseStyle.ctaHeadline}>
          {valuePropText}
        </HeadlineFour>
        <Select
          className={style.ctaSelect}
          name='region'
          value={region}
          labelText={regionDropdown.placeholderText}
          options={regionDropdown.options}
          id='checkoutSelect'
          onChange={handleChangeRegion}
        />
        <Button disabled={region === ''} className={baseStyle.ctaButton}>
          {purchaseLinkText}
        </Button>
      </form>
    </div>
  )
}

export default PurchaseCTA
